import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "firesafety-fire-exit-left",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "fire exit left",
    description: "fire-exit-left",
    image: require("./fire-exit-left.svg"),
    svgIcon: require("./fire-exit-left.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g>
          <defs>
            <style>{`.fireexitleftcls1{fill:#009f4d;}.fireexitleftcls2{fill:#fff;}`}</style>
          </defs>
          <g
            transform={`translate(-47, 55) scale(1, -1)`}
            id={`${element.type}-${element.id}`}
            data-name="corner shower"
          >
            <path
              class="fireexitleftcls1"
              d="M45.82,84.81H1.21V1.15H84.65l.19,0V84.36c0,.15,0,.3,0,.45H82.74c-.07-.16-.12-.31-.19-.47l-2.38-5.91a1.16,1.16,0,0,1-.09-.4q0-4.35,0-8.68c0-.07,0-.14,0-.24h.68a3.94,3.94,0,0,0,.69,0,2.11,2.11,0,0,0,1.29-.91,3.71,3.71,0,0,0,0-4.21,2,2,0,0,0-1.38-.86,7.31,7.31,0,0,0-.81,0h-.47V31.23H43.5a1.32,1.32,0,0,0-.24,0V78.09a1.33,1.33,0,0,0,0,.2,2.2,2.2,0,0,0,.09.43c.5,1.26,1,2.51,1.52,3.77C45.18,83.27,45.5,84,45.82,84.81ZM24.43,42.92l0-.06H17.06a.82.82,0,0,0-.64.26Q10.3,49.25,4.15,55.39l-.22.23.19.22,12.4,12.41a.57.57,0,0,0,.44.18H24.1a.44.44,0,0,0,.34-.07l-10-10H40.38c.07-.32.06-5.28,0-5.52H14.77l-.23,0ZM20.2,7.06c0,.05,0,.07,0,.08a.71.71,0,0,0,0,.14V18.19a.31.31,0,0,0,0,.08v0l0,0a15.82,15.82,0,0,0,2.6,0v-2c0-.34,0-.68,0-1h1.94c.47,0,.35-.07.62.32l1.77,2.57a.4.4,0,0,0,.35.23c.81,0,1.62,0,2.43,0,0,0,.11,0,.22-.05l-2.48-3.56.29-.16a3.56,3.56,0,0,0,1.64-1.72,4.17,4.17,0,0,0,.31-2.26,3.68,3.68,0,0,0-2.45-3.12,6.41,6.41,0,0,0-2.37-.42H20.2Zm35.54,0H47.59c-.38,0-.38,0-.38.38V18.19a.14.14,0,0,0,.14.14h8.31l.26,0a10.1,10.1,0,0,0,0-2.13h-6V13.66H55a8,8,0,0,0,0-2.08H49.87V9.19h4.89c.33,0,.65,0,1,0ZM40.67,16.18H34.59V13.66H38c.57,0,1.14,0,1.71,0a8.92,8.92,0,0,0,0-2.08h-5.1a13.34,13.34,0,0,1,0-2.37H39c.48,0,1,0,1.46,0,0-.11,0-.19,0-.27V7.35c0-.29,0-.3-.3-.3H32.23c-.3,0-.31,0-.31.32V17.94c0,.12,0,.25,0,.36.35.06,8.48.05,8.72,0C40.68,17.61,40.68,16.93,40.67,16.18Zm20-3.59-1,1.43-1,1.43c-.35.47-.69.94-1,1.42s-.7.92-1,1.47h.34c.8,0,1.6,0,2.4,0a.45.45,0,0,0,.45-.24L62,14.77l.21-.3.21.29c.78,1.12,1.56,2.24,2.33,3.37a.43.43,0,0,0,.39.21c.84,0,1.69,0,2.53,0a2.6,2.6,0,0,0,.28,0c-.37-.52-.72-1-1.07-1.47l-1-1.43L64.85,14l-1-1.45.16-.24c.32-.44.63-.88,1-1.31l2.61-3.62a2.24,2.24,0,0,0,.17-.29h-.34c-.73,0-1.46,0-2.2,0a.54.54,0,0,0-.5.27q-1,1.53-2.13,3.06l-.2.27c-.08-.11-.14-.18-.19-.26-.74-1-1.48-2.07-2.21-3.11A.44.44,0,0,0,59.52,7H57a2.1,2.1,0,0,0-.26,0ZM13.14,9.19a8.71,8.71,0,0,0,0-2.11c-.36-.07-8.26,0-8.46,0V18.29a14.38,14.38,0,0,0,2.63,0v-2c0-.66,0-1.33,0-2h4.77l.39,0V12.11H7.64l-.31,0a23,23,0,0,1,0-2.9Zm63.39.05v7.27c0,.6,0,1.2,0,1.79a15.26,15.26,0,0,0,2.64,0V11.51c0-.75,0-1.49,0-2.28H82.4l.34,0a10.1,10.1,0,0,0,0-2.14H73a8.28,8.28,0,0,0,0,2.17ZM14.92,18.32l.31,0h2a.66.66,0,0,1,.14,0c.14,0,.21-.06.2-.2V18c0-3.56,0-7.12,0-10.68,0-.29,0-.3-.29-.3H15.19l-.27,0Zm56.65,0c0-.06,0-.09,0-.11V7.29a1,1,0,0,0,0-.17s0,0,0,0l0,0A18.33,18.33,0,0,0,69,7.1s0,.05,0,.08V18.07a1.36,1.36,0,0,0,0,.2v0l0,0Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M45.82,84.81c-.32-.77-.64-1.54-1-2.32-.51-1.26-1-2.51-1.52-3.77a2.2,2.2,0,0,1-.09-.43,1.33,1.33,0,0,1,0-.2V31.26a1.32,1.32,0,0,1,.24,0H80.07V63h.47a7.31,7.31,0,0,1,.81,0,2,2,0,0,1,1.38.86,3.71,3.71,0,0,1,0,4.21,2.11,2.11,0,0,1-1.29.91,3.94,3.94,0,0,1-.69,0H80.1c0,.1,0,.17,0,.24q0,4.34,0,8.68a1.16,1.16,0,0,0,.09.4l2.38,5.91c.07.16.12.31.19.47Zm9.68-31,4.81,5.57-.25.26-4,4a2.26,2.26,0,0,0-.65,2.11c.1.61.26,1.2.39,1.8.73,3.24,1.47,6.48,2.18,9.72A2.1,2.1,0,0,0,60.05,79a2.06,2.06,0,0,0,2-2,4.25,4.25,0,0,0-.15-1Q61,71.82,60,67.7a.52.52,0,0,1,.17-.56q2.28-2.19,4.54-4.4l.24-.22.26.27,4,4.4a2.36,2.36,0,0,0,.83.6,4,4,0,0,0,1.6.29h8.64a3.82,3.82,0,0,0,.59,0,2.06,2.06,0,0,0,1.06-3.53A2,2,0,0,0,80.47,64L73.3,64a.64.64,0,0,1-.54-.25l-6.23-7.23-4.38-5.09-.22-.27.15,0,2.54,0a.52.52,0,0,1,.4.21q1.71,2,3.43,4c.48.55,1,1.11,1.44,1.66a1.52,1.52,0,0,0,1.53.53,1.59,1.59,0,0,0,.81-2.68,2.73,2.73,0,0,1-.23-.25q-1.62-1.86-3.23-3.73l-2-2.29a1.58,1.58,0,0,0-1.26-.6h-.67l-7,0a2.21,2.21,0,0,0-1.34.39,3.23,3.23,0,0,0-.4.35l-4.61,4.61-.27.25c-.12-.11-.21-.19-.3-.29l-3.75-3.74a1.55,1.55,0,0,0-1.56-.43,1.63,1.63,0,0,0-.76,2.74q2.41,2.46,4.85,4.89a3.8,3.8,0,0,0,.59.47,1.43,1.43,0,0,0,.72.26,1.7,1.7,0,0,0,1.46-.54l2.78-2.79ZM53.73,42.37a3.17,3.17,0,0,0-3.19,3.18,3.19,3.19,0,1,0,6.38,0A3.18,3.18,0,0,0,53.73,42.37Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M84.85,84.81c0-.15,0-.3,0-.45V1.18l-.19,0H1.21s0-.06,0-.06H84.91V84.56C84.91,84.64,85,84.75,84.85,84.81Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M24.43,42.92l-9.89,9.9.23,0h25.6c.07.24.08,5.2,0,5.52H14.49l10,10a.44.44,0,0,1-.34.07H17a.57.57,0,0,1-.44-.18L4.12,55.84l-.19-.22.22-.23q6.14-6.15,12.27-12.29a.82.82,0,0,1,.64-.26H24.4Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M20.2,7.06h4.88a6.41,6.41,0,0,1,2.37.42,3.68,3.68,0,0,1,2.45,3.12,4.17,4.17,0,0,1-.31,2.26A3.56,3.56,0,0,1,28,14.57l-.29.16,2.48,3.56c-.11,0-.17.05-.22.05-.81,0-1.62,0-2.43,0a.4.4,0,0,1-.35-.23l-1.77-2.57c-.27-.39-.15-.32-.62-.32H22.81c0,.36,0,.7,0,1v2a15.82,15.82,0,0,1-2.6,0l0,0v0a.31.31,0,0,1,0-.08V7.28a.71.71,0,0,1,0-.14S20.18,7.11,20.2,7.06Zm2.62,6h2.12l.72-.06a1.73,1.73,0,0,0,1.55-1.48,2.74,2.74,0,0,0,0-.64,1.62,1.62,0,0,0-1.12-1.46,2.81,2.81,0,0,0-.86-.18c-.75,0-1.49,0-2.23,0l-.2,0Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M55.74,7.05V9.18c-.33,0-.65,0-1,0H49.87v2.37H55a8,8,0,0,1,0,2.08H49.87v2.53h6a10.1,10.1,0,0,1,0,2.13l-.26,0H47.35a.14.14,0,0,1-.14-.14V7.43c0-.38,0-.38.38-.38h8.15Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M40.67,16.18c0,.75,0,1.43,0,2.1-.24.07-8.37.08-8.72,0,0-.11,0-.24,0-.36V7.37c0-.32,0-.32.31-.32h7.94c.29,0,.3,0,.3.3V8.91c0,.08,0,.16,0,.27-.5,0-1,0-1.46,0H34.62a13.34,13.34,0,0,0,0,2.37h5.1a8.92,8.92,0,0,1,0,2.08c-.57,0-1.14,0-1.71,0H34.59v2.52Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M60.71,12.59l-3.93-5.5a2.1,2.1,0,0,1,.26,0h2.48a.44.44,0,0,1,.41.23c.73,1,1.47,2.08,2.21,3.11,0,.08.11.15.19.26l.2-.27q1.08-1.53,2.13-3.06a.54.54,0,0,1,.5-.27c.74,0,1.47,0,2.2,0h.34a2.24,2.24,0,0,1-.17.29L64.92,11c-.32.43-.63.87-1,1.31l-.16.24,1,1.45L65.9,15.4l1,1.43c.35.48.7,1,1.07,1.47a2.6,2.6,0,0,1-.28,0c-.84,0-1.69,0-2.53,0a.43.43,0,0,1-.39-.21C64,17,63.24,15.88,62.46,14.76l-.21-.29-.21.3L59.76,18.1a.45.45,0,0,1-.45.24c-.8,0-1.6,0-2.4,0h-.34c.34-.55.7-1,1-1.47s.68-1,1-1.42l1-1.43Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M13.14,9.19H7.36a23,23,0,0,0,0,2.9l.31,0h4.84v2.12l-.39,0H7.32c0,.69,0,1.36,0,2v2a14.38,14.38,0,0,1-2.63,0V7.11c.2-.07,8.1-.1,8.46,0A8.71,8.71,0,0,1,13.14,9.19Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M76.53,9.24H73a8.28,8.28,0,0,1,0-2.17h9.73a10.1,10.1,0,0,1,0,2.14l-.34,0H79.19c0,.79,0,1.53,0,2.28v6.76a15.26,15.26,0,0,1-2.64,0c0-.59,0-1.19,0-1.79V9.24Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M14.92,18.32V7.07l.27,0h2.07c.28,0,.29,0,.29.3,0,3.56,0,7.12,0,10.68v.11c0,.14-.06.2-.2.2a.66.66,0,0,0-.14,0h-2Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls2"
              d="M71.57,18.32H69l0,0v0a1.36,1.36,0,0,1,0-.2V7.18s0,0,0-.08a18.33,18.33,0,0,1,2.58,0l0,0s0,0,0,0a1,1,0,0,1,0,.17V18.21S71.58,18.26,71.57,18.32Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls1"
              d="M55.5,53.84l-.25.24-2.78,2.79a1.7,1.7,0,0,1-1.46.54,1.43,1.43,0,0,1-.72-.26,3.8,3.8,0,0,1-.59-.47q-2.43-2.43-4.85-4.89a1.63,1.63,0,0,1,.76-2.74,1.55,1.55,0,0,1,1.56.43l3.75,3.74c.09.1.18.18.3.29l.27-.25,4.61-4.61a3.23,3.23,0,0,1,.4-.35,2.21,2.21,0,0,1,1.34-.39l7,0h.67a1.58,1.58,0,0,1,1.26.6l2,2.29q1.61,1.88,3.23,3.73a2.73,2.73,0,0,0,.23.25,1.59,1.59,0,0,1-.81,2.68A1.52,1.52,0,0,1,69.89,57c-.49-.55-1-1.11-1.44-1.66q-1.73-2-3.43-4a.52.52,0,0,0-.4-.21l-2.54,0-.15,0,.22.27,4.38,5.09,6.23,7.23a.64.64,0,0,0,.54.25l7.17,0a2,2,0,0,1,1.43.52,2.06,2.06,0,0,1-1.06,3.53,3.82,3.82,0,0,1-.59,0H71.61a4,4,0,0,1-1.6-.29,2.36,2.36,0,0,1-.83-.6l-4-4.4L65,62.52l-.24.22q-2.27,2.2-4.54,4.4a.52.52,0,0,0-.17.56Q61,71.83,61.89,76A4.25,4.25,0,0,1,62,77a2.06,2.06,0,0,1-2,2A2.1,2.1,0,0,1,58,77.3c-.71-3.24-1.45-6.48-2.18-9.72-.13-.6-.29-1.19-.39-1.8a2.26,2.26,0,0,1,.65-2.11l4-4,.25-.26Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls1"
              d="M53.73,42.37a3.18,3.18,0,0,1,3.19,3.18,3.19,3.19,0,1,1-6.38,0A3.17,3.17,0,0,1,53.73,42.37Z"
              transform="translate(-1.21 -1.09)"
            />
            <path
              class="fireexitleftcls1"
              d="M22.82,13.06V9.27l.2,0c.74,0,1.48,0,2.23,0a2.81,2.81,0,0,1,.86.18,1.62,1.62,0,0,1,1.12,1.46,2.74,2.74,0,0,1,0,.64A1.73,1.73,0,0,1,25.66,13l-.72.06H22.82Z"
              transform="translate(-1.21 -1.09)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
